
export default {
    name: 'LeeRadio',
    inheritAttrs:false,
    data() {
        return {

        };
    },
    inject: ['radio'],
    props: {
        label:{
            type:Number,
            default:1
        }
    },
    methods:{
        selc(el){
            this.radio.$emit('input',el)
        }
    },
    computed: {

    }
};
